import request from '../../utils/requests'
/** * Tag: WXFlowStatistics */
const baseUrl ="/api/WXFlowStatistics";

/** * 获取机构微信流量统计 */async function _getOrgWxFlowStatistics() {  return request(baseUrl+'/getOrgWxFlowStatistics',{    method: 'GET',  });
}

/** * 流量详情统计 * @param {*} body * { *    DataType Desc:数据类型  1.累计访问用户数 2.打开次数 3.访问次数 4.访问人数  5.新访问用户数  6.分享次数  7.分享人数  8.人均停留时长  9.次均停留时长 Required:false *    OrginalDataStartTime Desc:元数据开始时间 Required:false *    OrginalDataEndTime Desc:元数据结束时间 Required:false *    CompareDataStartTime Desc:比较数据开始时间 Required:false *    CompareDataEndTime Desc:比较数据结束时间 Required:false * } */async function _getOrgWxFlowDetailStatistics(body) {  return request(baseUrl+'/getOrgWxFlowDetailStatistics',{    method: 'POST',    body: body,  });
}

export default{  _getOrgWxFlowStatistics,  _getOrgWxFlowDetailStatistics}



// WEBPACK FOOTER //
// ./src/services/wXFlowStatistics.js